<template>
  <div class="modal fade modern-test-modal" tabindex="-1" :aria-labelledby="ModalName + '-title'" v-bind:id="ModalName" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-heading"><span class="modal-eyebrow">GEÇMİŞ SONUÇLAR</span><h1 :id="ModalName + '-title'" class="modal-title">{{ Title }}</h1></div>
          <button type="button" class="btn-close" aria-label="Kapat" @click="CloseModal()"></button>
        </div>
        <div class="modal-body history-body">
          <div v-if="!exercises.length" class="history-empty">
            <span class="empty-icon"><i class="bi bi-bar-chart" aria-hidden="true"></i></span>
            <h2>Henüz bir sonuç yok</h2><p>Testi tamamladığında sonuçlarını burada görebilirsin.</p>
          </div>
          <template v-else>
            <div class="history-intro"><p>Önceki denemelerini buradan inceleyebilirsin.</p><span>{{ exercises.length }} deneme</span></div>
            <div class="history-scroll" tabindex="0" role="region" aria-label="Geçmiş test sonuçları">
              <table class="table history-table">
                <caption class="visually-hidden">{{ Title }} geçmiş test sonuçları</caption>
                <thead><tr><th scope="col">Tarih</th><th scope="col">Doğru</th><th scope="col">Yanlış</th><th v-if="IsLevelTest" scope="col">Seviye</th></tr></thead>
                <tbody><tr v-for="(r, index) in exercises" :key="index">
                  <td class="history-date">{{ DateFormatWithOffset(r.startDate) }}</td>
                  <td><span class="score-badge correct">{{ r.currectNumber }}</span></td>
                  <td><span class="score-badge incorrect">{{ r.inCurrectNumber }}</span></td>
                  <td v-if="IsLevelTest"><span class="score-badge level">{{ GetLevelTestPuan(r.currectNumber) }}</span></td>
                </tr></tbody>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {GetLevelTextByCurrectPuan} from '@/common/test-helper';
  import {DateFormat, CalculateDateTime} from '@/common/datetime-helper';
  import bootstrapBundle from 'bootstrap/dist/js/bootstrap.bundle';
  import { manageModalFocus } from '@/common/modal-focus';
  export default {
    name: "ExerciseResultModal",
    components:{
    },
    props: {
      ModalName:{
        type:String,
        default:'ModalExerciseResult'
      },
      Visible:{
        type:Boolean,
        default:false
      },
      Title:{
        type:String,
        default: null
      },
      ExcerciseResultData:{
        type:Object
      },
      IsLevelTest:{
        type:Boolean,
        default:false
      },
    },
    data() {
      return {
        modalElement:null,
        cleanupModalFocus:null,
      };
    },
    computed: {
      exercises(){
        let result = [];
        if(this.ExcerciseResultData && this.ExcerciseResultData.length>0){
            result = this.ExcerciseResultData;
        }
        return result;
      },
    },
    methods: {
      CloseModal(){
        this.modalElement.hide();
        this.$emit("CloseModal", false);
      },
      DateFormatWithOffset(value) {
          return DateFormat(CalculateDateTime(value), 'dd.mm.yyyy hh:MM:ss');
      },
      GetLevelTestPuan(value) {
          return GetLevelTextByCurrectPuan(value);
      }
    },
    watch: {
      Visible(value){
        if(value){
          this.modalElement.show();
        }
      }
    },
    mounted: function() {
      const element = document.getElementById(this.ModalName);
      this.cleanupModalFocus = manageModalFocus(element);
      this.modalElement = new bootstrapBundle.Modal(element,{backdrop: 'static',keyboard: false});
    },
    beforeUnmount() {
      this.cleanupModalFocus?.();
    }
  };
  </script>
  
  <style scoped src="../../assets/styles/test-modal.css"></style>
